// extracted by mini-css-extract-plugin
module.exports = {"arrowLink":"BackButton_arrowLink__1RQNE","arrowLinkIcon":"BackButton_arrowLinkIcon__2fkQi"};